<template>
	<div class="qualityenterprise">
		<leftnav class="fl" :itemcode="curPage.itemcode"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox has-title-font" style="padding-bottom: 1px;">
					<div class="right_boxtitle">
						<span class="fl right_title mt-1">{{curPage.title}}</span>
						<p class="fl titlefont" v-html="curPage.titlefont"></p>
						<div class="fl search-box nz-search-box">
							<span class="searchtype">全部内资企业库</span>
							<input type="text" placeholder="请输入企业名称" class="search-input" v-model="searchtext"
								@keydown="searchenter" />
							<button class="search-btn" @click="searchkwfun">查询</button>
						</div>
					</div>
					<div class="opport-screen-list1">
						<!-- 全部内资企业的企业实力 -->
						<dl class="opport-screen bdbe" v-show="search_type == 'strength'">
							<dt class="fl">企业实力</dt>
							<dd class="fl ">
								<!--  	:style=" index<7?'font-weight:bold':''" -->
								<span @click="setTabCode(1,'empty')" :class="tagcode_list[0] == 'empty' ?'a-screen current' : 'a-screen'">全部</span>
								<span :key="item.tagCode" v-for="(item,index) in qysl_taglist" 	@click="setTabCode(1,item.tagCode)" 
								:class="tagcode_str.indexOf(item.tagCode)>-1 ?'a-screen current' : 'a-screen'">{{item.tagName}}</span>
						  </dd>
						</dl>
							<!-- 省市区筛选 -->
						<cityScreen :key="refreshCity" @getEnterpriseList="cityScreenFun"  v-if="search_type != 'notion'"></cityScreen>
						<!-- 概念产业筛选 -->
						<notionScreen :type="2" :key="pageRefreshKey" :notionNumberList="notionNumList" :refreshNum="notionNumRefresh"
							:token="userdata.token" @chooseNotion="chooseNotion" :isShowNotionScreen="true"
							:isClearNotion="isClearNotion"></notionScreen>
							
					</div>
				</div>
				<div class="whitebox" style="min-height: 160px;">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" v-if="!kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
						<p class="fl" v-if="kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条【 <span
								class="orangefont">{{kwtextsearchtext}}</span>】相关结果</p>
						<div :class="exportbtn?'fr enlistexportbtn':'fr enlistexportbtn disable'"
							@click="enlistExport()" v-if="userdata.groupType == 1"
							v-show="exportnum>0 && enterprise_list.length>0">
							<span>导出数据</span>
						</div>
					</div>
					<!-- 多维度分数筛选 全部内资企业删除排序功能-->
					<ul class="dimensionScreen oh w95mg" v-show="enterprise_list.length>0">
						<li :class="orderField == list.type ?'fl current ':'fl '" :key="index"
							v-for="(list,index) in dimensionList" @click="tablesort(list.type);" >
							<span :class="orderField == list.type ?'sortname current ':'sortname '">{{list.name}}</span>
							<span :class="orderType == 1?'timesorticon up':'timesorticon down'"></span>
						</li>
					</ul>
					<div class="enterprise_list_box" v-show="enterprise_list.length!=0">
						<!-- 全部内资企业 普通的 不带筛选项的 内资企业表格-->
						<domesticTable :list="enterprise_list" :page="page"></domesticTable>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="getEnterpriseList"></zpagenav>
					</div>
				</div>
			</div>
			<!-- 导出列表弹框 -->
			<div class="enlistexportPop" v-show="exportpop">
				<div class="enlistexportPop_box">
					<h5 class="title">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</h5>
					<p class="smtips">单次最多导出500条，每日最多可以导出10次</p>
					<p class="tips">本次可导出<b class="redfont">{{total>500?500:total}}</b>条，今日剩余次数<b
							class="redfont">{{exportnum}}</b>次</p>
					<span class="determinebtn" @click="exportlistFun()">{{confirmtext}}</span>
					<span class="closebtn" @click="exportpop=false"></span>
				</div>
			</div>
			<iframe :src='iframeurl' style="width: 1px;height: 1px;" frameborder="none" id="exportIframe"></iframe>
		</div>
	</div>
</template>

<script> 
import {totalqysl_simple} from '@/utils/enterprise-tag.js'
import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'enterpriseList',
		computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
		data() {
			return {
				search_type:"notion",// notion（只有概念）  city （概念 城市）  strength（企业实力， 概念 城市）
				pageList:[
					{type:'notion',itemcode:"A-ZDCYZQY",title:"按重点产业找企业",titlefont:"产业链招商，要能够用最简单快捷的方式，找到重点产业及细分产业的龙头企业；<br>在本页面，只需要不断点击一级、二级、三级、四级产业标签，下面就是对应龙头企业。"},
					{type:'city',itemcode:'A-ZDCSZQY',title:"按重点城市找企业",titlefont:'重点区域招商、外派驻点招商，要能够快速找到某个城市重点产业的目标企业。<br>选个一个省份、再选择一个城市，还可以再选择产业标签，目标企业自动呈现出来。'},
					{type:'strength',itemcode:'A-QYLXZQY',title:"按企业类型找企业",titlefont:'招大引强，需要锁定三个500强、央企、国企、上市公司等企业；<br>招新引优，需要重点关注专精特新、独角兽、隐形冠军和新三板等企业。'}
					],
				curPage:{type:"",itemcode:'A-ZDCYZQY',titlefont:""},
				curWebsite:this.$api.getWebsiteType(),
				title: "全部内资企业-简易版",
				searchPlaceholder: '请输入企业名称',
				fenkd: {
					children: []
				},
				userdata: {},
				notionCode: 0,
				chooseNotionlist: [0, 0, 0, 0, 0], 
				notionNumRefresh:1,
				isClearNotion:false,
				notionstep: 0,
				notionNumList:[], 
				provinceid: 0,
				cityid: 0,
				countyid: 0, 
				refreshCity:1,
				pageRefreshKey:1,
		  qysl_taglist:[],
				tagcode_str:"",
				tagcode_list:['empty'],
				// provincedata: dataInJs(),
				// citydata: [],
				// countydata: [], 
				searchtext: "",
				kwtextsearch: false,
				kwtextsearchtext: "",
				enterprise_list: [],
				exportnum: 0, //导出次数
				exportpop: false, //点击导出按钮弹框显示
				allowexport: false, //后台判断是否可以上传
				exportbtn: true, //loading小 等待转圈圈
				confirmtext: '确认导出',
				iframeurl: '', 
				orderField: 0, //排序字段 0 分数 1 时间
				orderType: 0, //排序方式 0 降序 1 升序   
				// 0=分数,1=融资时间,2=企业实力,3=投资力度,4=本省关联度,5=拿地数量,6=拿地面积,7=拿地金额,8=投资项目数量,9=投资项目金额,10=控制企业数量,11=专利数量
				dimensionList: [{
					name: '综合',
					type: 0
				}, {
					name: '拿地数量',
					type: 5
				}, {
					name: '拿地面积',
					type: 6
				}, {
					name: '拿地金额',
					type: 7
				}, {
					name: '投资项目数量',
					type: 8
				}, {
					name: '投资项目金额',
					type: 9
				}, {
					name: '控制企业',
					type: 10
				}, ],
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数 
			}},
			created() {
				this.$nextTick(() => { 
					document.oncontextmenu = new Function("event.returnValue=false"); // 禁用右键 
					document.onselectstart = new Function("event.returnValue=false"); // 禁用选择
				}); 
				this.userdata = this.getuseriformation();
			},
			mounted(){   
				this.qysl_taglist=totalqysl_simple(); 
				this.getCurPage();
			},
			watch: {
				$route: function(newVal, oldVal) {   
					this.getCurPage()
				}
			},
			methods: {
				//企业列表导出数据
				enlistExport() {
					if (this.exportbtn) {
						this.exportpop = true;
					} 
				},
				exportlistFun() { //下载报告
					var _this = this;
					// var isnotiontoggle = citytype == 'sort' && this.notionCode != 0; 
					var notionja = this.splicing('notion', this.notionCode);  
					var tagaja = _this.splicing('tag', this.tagcode_str); 
					var ajaxurl = this.$api.cyl.enterprise.export() +'?type=0&search=1&orderField=' + this.orderField + '&orderType=' + this.orderType +notionja+tagaja+'&page=' + this.page +'&token=' + this.userdata.token;;
					// var ajaxurl = this.getajaxUrl(this.$api.cyl.enterprise.export(), 'search') + '&token=' + this.userdata.token;
					this.confirmtext = "导出中";
					var iframe = document.getElementById("exportIframe");
					iframe.setAttribute("src", ajaxurl);
					_this.exportnum = this.exportnum--;
					setTimeout(() => {
						_this.confirmtext = "导出成功";
						_this.exportpop = false;
						_this.exportbtn = false;
					}, 5000)
					setTimeout(() => {
						_this.exportbtn = true;
						_this.confirmtext = "确认导出";
						console.log('一分钟冷却计时')
					}, 60000)
				},
				//企业实力筛选
				setTabCode(indexs,code){
					this.tagcode_list[indexs-1]=code;
					var taglist=this.tagcode_list.filter(list=>{
						return list!='empty' && list!=0;
					}); 
					this.tagcode_str=taglist.join(',');
					this.clearNotion();
					this.getEnterpriseList();
				},
				//时间/分数升降序
				tablesort(field) {
					if (field == this.orderField) {
						this.orderType = Math.abs(this.orderType - 1);
					} else {
						this.orderField = field;
					}
					this.getEnterpriseList();
				},
				//获取当前页面的类型信息
				getCurPage(){
					this.search_type = this.$route.query.type ? this.$route.query.type : 'notion'; 
					var type=this.search_type;
					let arry=this.pageList.filter(list=>{
						return list.type == type;
					});
					this.curPage=arry[0];
					this.refreshCity++;
					this.clearNotion();
					this.provinceid=0;this.cityid=0;this.countyid=0;
					this.getEnterpriseList();
				},
				//获取企业列表
				getEnterpriseList(pages, citytype, searchtype) {
					this.bus.$emit('loading', true);
					this.page = pages ? pages : 1;
					var _this = this; 
					var isnotiontoggle = citytype == 'sort' && this.notionCode != 0; 
					var calcnc = isnotiontoggle ? '&calNotion=1&calCNC=1' :'';  
					var notionja = this.splicing('notion', this.notionCode);  
					var tagaja = _this.splicing('tag', this.tagcode_str); 
					var countyidja = this.splicing('county', this.countyid);
					var provinceidja = this.splicing('province', this.provinceid);
					var cityidja = this.splicing('city', this.cityid);
					var ajaxurl = this.$api.cyl.enterprise.list() +'?type=0&search=1&orderField=' + this.orderField + '&orderType=' + this.orderType +notionja+tagaja+
					calcnc+countyidja+provinceidja+cityidja+'&page=' + this.page+'&ver=1' ;
					// console.log(ajaxurl)
					this.$axios.get(ajaxurl, {
						headers: {
							AuthToken: this.userdata.token
						}
					}).then(function(res) {
						console.log('企业列表', res.data);
						if (res.data.success) {
							var dataenterlist = res.data.list;
							_this.exportnum = res.data.extend.exportRemainder;
							_this.allowexport = res.data.extend.allowExport;
							if(isnotiontoggle){
								_this.isClearNotion=false;
								_this.notionNumRefresh++;
								_this.notionNumList=res.data.extend.cityNotionList;  
							}
							for (var i = 0; i < res.data.list.length; i++) {
								dataenterlist[i].notionlist = _this.taglistfun(dataenterlist[i].notion, dataenterlist[
									i].notionCode, 'notionsort');
								dataenterlist[i].taglist = _this.taglistfun(dataenterlist[i].tag, dataenterlist[i]
									.tagCode);
							}
							_this.totalPage = res.data.totalPage;
							_this.pageSize = res.data.pageSize;
							_this.total = res.data.totalRecord;
							_this.haspage = res.data.list.length == res.data.pageSize;
							_this.kwtextsearch = _this.searchtext != "";
							_this.kwtextsearchtext = _this.searchtext;
							_this.exportbtn = true;
							_this.confirmtext = "确认导出";
							_this.enterprise_list = dataenterlist;
							_this.bus.$emit('loading', false); 
						}  
					}).catch(function(error) {});
					// console.log(datas);  
				},
				cityScreenFun(pid,cid,cuid){
					this.clearNotion();
					this.cityid = cid;
					this.countyid = cuid; 
					this.provinceid = pid;
					this.getEnterpriseList(1, 'sort');
				}, 
				//清空概念选项
				clearNotion() {
					this.notionNumRefresh++;
					this.isClearNotion=true; 
					this.notionCode = 0;
				},
				//概念单选 层级显示
				chooseNotion(chooseNotionlist,notionCode,step){ 
					this.notionCode=notionCode;  
					if(step){
						this.notionstep = step; 
					}
					var sortStr =  (step && step < 3) ? 'sort':''; 
					this.getEnterpriseList(1,sortStr); 
				},
				//搜索关键词
				searchkwfun() {
					this.searchtext = $.trim(this.searchtext);
					if (this.searchtext.length > 0) {
						var pathque = {
							kw: this.searchtext
						};
						this.routerlinkarry('/totalSearch', pathque);
					} else {
						this.$message({
							type: 'error',
							message: '请输入关键词搜索',
						});
					}
				},
				searchenter(e) {
					if (e.keyCode == 13) {
						this.searchkwfun();
					}
				},
				//省份城市选择
				// provincechoose(id, i) {
				// 	if (this.provinceid != id) {
				// 		this.clearNotion();
				// 		this.cityid = 0;
				// 		this.countyid = 0; 
				// 		this.provinceid = id;
				// 		this.countydata = [];
				// 		if (i != "all" && this.provincedata[i].children != null) {
				// 			this.citydata = this.provincedata[i].children;
				// 		} else {
				// 			this.citydata = [];
				// 		}
				// 		this.getEnterpriseList(1, 'sort');
				// 	}
				// },
				
				// choosecity(id, i) {
				// 	//	console.log('choosecity',id);
				// 	if (this.cityid != id) {
				// 		this.clearNotion();
				// 		this.cityid = id;
				// 		this.countyid = 0;
				// 		if (i != "all" && this.citydata[i].children != null) {
				// 			this.countydata = this.citydata[i].children;
				// 		} else {
				// 			this.countydata = [];
				// 		}
				// 		this.page = 1;
				// 		this.getEnterpriseList(1, 'sort');
				// 	}
				// },
				// choosecounty(id) {
				// 	//	console.log('choosecity',id);
				// 	this.clearNotion();
				// 	this.countyid = id;
				// 	this.page = 1;
				// 	this.getEnterpriseList();
				// },
			},
	}
</script>

<style>
</style>